import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface EntityCapState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allEntityCap: [] | null | any;
}

const initialState: EntityCapState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allEntityCap: null,
};

export const entityCapSlice = createSlice({
    name: 'EntityCap',
    initialState,
    reducers: {
        setAllEntityCap: (state, action) => {
            state.allEntityCap = action.payload.data;
        },

        setEntityCap: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },

        setAllEntityCapBySearch: (state, action) => {
            state.data = action.payload.data.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },

        reset: (state) => {
            state = initialState;
        },
    },
});

// ✅ Actions
export const {
    setAllEntityCap,
    setEntityCap,
    setAllEntityCapBySearch,
    reset,
} = entityCapSlice.actions;

// ✅ Selectors
export const allEntityCapDetails = (state: RootState) =>
    state.entityCap.allEntityCap;

export const getAllEntityCapDetails = (state: RootState) =>
    state.entityCap.data;

export const getEntityCapTotalRecords = (state: RootState) =>
    state.entityCap.totalRecords;

export const getAllEntityCapBySearch = (state: RootState) =>
    state.entityCap.data;

// ✅ Reducer
export default entityCapSlice.reducer;
